// extracted by mini-css-extract-plugin
var _1 = "CheckableTag_checked__064c6";
var _2 = "CheckableTag_clearButton__a85c6";
var _3 = "CheckableTag_disabled__de557";
var _4 = "CheckableTag_root__3ae73";
var _5 = "CheckableTag_tag__b4400";
export { _1 as "checked", _2 as "clearButton", _3 as "disabled", _4 as "root", _5 as "tag" }
